import * as z from 'zod';
import { ViewMode } from '../../viewMode/model';

export const schemaV2 = z.object({
  version: z.literal(2),
  data: z.object({
    category: z.object({
      selectedId: z.string(),
      expandedKeys: z.string().array(),
    }),
    extension: z.object({
      selectedIds: z.string().array(),
      expandedKeys: z.string().array(),
    }),
    finder: z.object({
      selected: z
        .object({
          ids: z.number().array(),
          firstId: z.number().optional(),
          lastId: z.number().optional(),
        })
        .optional(),
      detailsVisible: z.boolean(),
    }),
    project: z.object({
      selectedId: z.number(),
    }),
    search: z.object({
      text: z.string(),
    }),
    sorting: z.object({
      order: z.string(),
      fieldKey: z.string(),
    }),
    tag: z.object({
      selectedIds: z.number().array(),
      expandedMode: z.boolean(),
    }),
    viewMode: z
      .object({
        value: z.union([z.literal(ViewMode.assets), z.literal(ViewMode.creatives)]).optional(),
        expanded: z.boolean().optional(),
      })
      .optional(),
    viewer: z
      .object({
        creative: z.object({ id: z.number(), name: z.string() }).optional(),
      })
      .optional(),
  }),
});
